import { ListingEditorProps, ListingEditorState } from "../components/listings/listing-editor.component";
import { FieldList, Field, Form } from "../../utils/forms/form";
import { Amenity } from '../../../types/listing.model';

import * as Validators from '../../utils/forms/validators';

/*
  The idea behind this is to move out field declaration from
  actual components so that the amount of taken is reduced
  on the component.tsx file.

  Add necessary function parameters and imports as needed.
// */

export const validUrlRegex = /^https?:\/\//;

const urlValidator = (field: Field, form: Form) => {
  const url = field.value;
  
  return !url || validUrlRegex.test(url);
}

function getAmenityValue(fieldName: string, amenities: Amenity[]) {
  let amenity = amenities.find(m => { 
    return fieldName.toLowerCase() === m.field.toLowerCase(); 
  });
  return amenity.value;
}

export const constructFields = (
  props: ListingEditorProps,
  state?: ListingEditorState
): FieldList => {

  // Please note that there is a unique handling for parkingSpaces
  // Since the value of the checkbox is supposed to open up an
  // input but then be serialized as an array of Amenity,
  // we have this.
  let parkingSpaces: Amenity = props.listing.amenities.find(
    amenity => amenity.field === 'Parking Spaces'
  );
  const listing = props.listing;

  let fields: FieldList = {
    'division':     new Field([Validators.required], null, listing.division),
    'category':     new Field([Validators.required], null, listing.category),
    'type':         new Field([Validators.required], null, listing.type),
    'minLeaseTerm': new Field([], null, listing.minLeaseTerm),
    'rentalPrice':  new Field([], null, listing.minPrice),
    'salePrice':    new Field([], null, listing.minPrice),
    'maxPrice':     new Field([], null, listing.maxPrice),
    'discountedPrice':     new Field([], null, listing.discountedPrice),
    'pricePerSqm':  new Field([], null, listing.pricePerSqm),
    'ownerReceipt': new Field([], null, listing.ownerReceipt),
    'associationDuesIncluded': new Field([], null, listing.associationDuesIncluded),
    'associationDues': new Field([], null, listing.associationDues),
    'floorArea':    new Field([], null, listing.floorArea),
    'lotArea':      new Field([], null, listing.lotArea),
    'furnishing':   new Field([], null, listing.furnishing),
    'condition':    new Field([], null, listing.condition),
    'bedrooms':     new Field([], null, listing.bedrooms),
    'bathrooms':    new Field([], null, listing.bathrooms),
    'restRoom':     new Field([], null),
    'dateAvailability': new Field([Validators.required], null,
      listing.dateAvailability ? listing.dateAvailability : listing.dateAvailability
    ),

    // Video URLs
    'tour360Url':   new Field([], [ urlValidator ], listing.tour360Url),
    'videoUrl':     new Field([], [ urlValidator ], listing.videoUrl),
    'liveVideoUrl': new Field([], [ urlValidator ], listing.liveVideoUrl),

    // Amenities
    'aircon':       new Field([], null, getAmenityValue('Aircon', listing.amenities)),
    'balcony_terrace': new Field([], null, getAmenityValue('Balcony/Terrace', listing.amenities)),
    'cableTv':      new Field([], null, getAmenityValue('Cable Tv', listing.amenities)),
    'clubhouse':    new Field([], null, getAmenityValue('Clubhouse', listing.amenities)),
    'den':          new Field([], null, getAmenityValue('Den', listing.amenities)),
    'functionRoom': new Field([], null, getAmenityValue('Function Room', listing.amenities)),
    'garden':       new Field([], null, getAmenityValue('Garden', listing.amenities)),
    'gym':          new Field([], null, getAmenityValue('Gym', listing.amenities)),
    'internet':     new Field([], null, getAmenityValue('Internet Access', listing.amenities)),
    'maidsRoom':    new Field([], null, getAmenityValue("Maid's Room", listing.amenities)),
    'petFriendly':  new Field([], null, getAmenityValue('Pet Friendly', listing.amenities)),
    'playground':   new Field([], null, getAmenityValue('playground', listing.amenities)),
    'porch_lanai':  new Field([], null, getAmenityValue('Porch/Lanai', listing.amenities)),
    'security':     new Field([], null, getAmenityValue('Security', listing.amenities)),
    'swimmingPool': new Field([], null, getAmenityValue('Swimming Pool', listing.amenities)),
    '__hasParking': new Field([], null, parkingSpaces && parkingSpaces.value ? 1 : 0),
    'parkingSpaces':new Field([], null, parkingSpaces && parkingSpaces.value ? parkingSpaces.value : null),
    'contactName':  new Field([], null, listing.contactName),
    'contactEmail': new Field([], null, listing.contactEmail),
    'contactNumber':new Field([], null, listing.contactNumber),
    'notes':        new Field([], null, listing.notes),

    'description':  new Field([], null, listing.description),
    'feStatus':     new Field([], null, listing.feStatus),
    'onHoldReason': new Field([], null, listing.onHoldReason),

    'preSale':      new Field([], null, listing.preSale),
    'dateTurnover': new Field([], null, listing.dateTurnover),    
    'restroom':     new Field([], null, listing.restroom),
    'source':       new Field([], null, listing.source),
  }

  return fields;
}